import moment from 'moment';
import {
  FETCH_TRIAL_SUCCESS,
  FETCH_TRIAL_START,
  FETCH_TRIAL_FAIL,
  UPDATE_TRIALS_SURVEY,
  RESTORE_SURVEY_PAYLOAD,
  SET_SURVEY_PAYLOAD_RESTORED,
  SET_YEAR_FILTER,
  SET_TRIAL_LIST,
  TrialActionTypes,
  TrialState,
} from '../types';

const initialState: TrialState = {
  isFetching: false,
  trial: undefined,
  /* When filling the survey we check if the questions of type OneOf, Multiple or Arbitrary
  string types are empty or incomplete. If they are incomplete then we set the incomplete flag in
  survey.payload.sections.question. This incomplete flag causes to make question
  turn red as a warning. To restore the incomplete state we restore the survey from
  this surveyPayloadCopy back to the trials.survey.payload to refresh the incomplete flags */
  surveyPayloadCopy: null,
  surveyPayloadRestored: false,
  trialList: [],
  yearFilter: moment().utc().format('YYYY'),
};

function TrialReducer(state = initialState, action: TrialActionTypes): TrialState {
  switch (action.type) {
    case FETCH_TRIAL_START:
      return {
        ...state,
        isFetching: true,
      };
    case FETCH_TRIAL_SUCCESS:
      return {
        ...state,
        isFetching: false,
        trial: action.payload,
        surveyPayloadCopy: action.payload.survey ? action.payload.survey.payload : null,
      };
    case FETCH_TRIAL_FAIL:
      return {
        ...state,
        isFetching: false,
      };
    case UPDATE_TRIALS_SURVEY:
    {
      if (state.trial) {
        const newTrial = { ...state.trial };
        newTrial.survey = action.payload;
        const newState = { ...state, trial: newTrial };
        return newState;
      }
      return state;
    }
    case RESTORE_SURVEY_PAYLOAD: {
      if (state.surveyPayloadCopy !== null && state.trial && state.trial.survey) {
        return {
          ...state,
          surveyPayloadRestored: true,
          trial: {
            ...state.trial,
            survey: {
              ...state.trial.survey,
              payload: state.surveyPayloadCopy,
            },
          },
        };
      }
      return state;
    }
    case SET_SURVEY_PAYLOAD_RESTORED:
      return {
        ...state,
        surveyPayloadRestored: action.payload,
      };
    case SET_YEAR_FILTER:
      return {
        ...state,
        yearFilter: action.payload,
      };
    case SET_TRIAL_LIST:
      return {
        ...state,
        trialList: action.payload,
      };
    default:
      return state;
  }
}

export default TrialReducer;
